/** map incoming errors from mp-node to user legible error messages */
export const errorMap = new Map([
  ['No survey job found for cut_id', 'no survey job(s) found for the following data cuts'],
  ['Error adding match', 'there was an error adding a match for the following data cuts'],
  ['match already exists for cut_id', 'a match already exists for the following data cuts']
]);
